import React, { useEffect, useState } from "react";
import Modal from "../Components/Base/Modal";
import { jobCampaignsService } from "../Services/jobCampaigns.service";
import { AlertCircle } from "lucide-react";

export default function ModelConfirmPublishCampaigns(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState("");
  console.log("amount", amount);
  const [isHovered, setIsHovered] = useState(false);

  const handleConfirm = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      await props.onConfirm();
    } catch (error) {
      console.error("Confirmation error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAmount = async () => {
    try {
      const res = await jobCampaignsService.fetchAmount();
      setAmount(res);
    } catch (error) {
      console.error("Fetch error:", error.message);
    }
  };

  useEffect(() => {
    fetchAmount();
  }, []);

  return (
    <Modal
      open={props.open}
      close={props.onClose}
      modelInnerClass="flex items-center justify-center right-5"
      className="right-20 top-4"
    >
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden transform transition-all scale-95 hover:scale-100">
        {/* Header */}
        <div className="p-6 bg-gradient-to-r from-green-50 to-emerald-50 border-b border-emerald-400">
          <div className="flex flex-col items-center">
            <div className="relative flex items-center justify-center w-20 h-20 bg-white rounded-full mb-4 shadow-lg ring-4 ring-white/80">
              <div className="absolute inset-0 bg-emerald-100 rounded-full animate-ping opacity-20"></div>
              <svg
                className="w-10 h-10 text-emerald-600 relative z-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-emerald-900  text-center mb-1">
              Publish Campaign
            </h3>
            <p className="text-sm text-emerald-700 text-center">
              Ready to make your{" "}
              <span className="font-medium text-emerald-900 ">
                "{props.campaignTitle}"
              </span>{" "}
              campaign live?
            </p>
          </div>
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="bg-gray-50 rounded-xl p-5 mb-5 border border-emerald-100">
            <p className="text-gray-700 text-center">
              You have{" "}
              <span className="font-bold text-emerald-700 text-lg">
                {amount?.data?.amount_available}
              </span>{" "}
              available Campaign quota, and you will be using{" "}
              <span className="font-bold text-emerald-700 text-lg ml-1">1</span>{" "}
              .
            </p>
          </div>

          {/* Progress indicator */}
          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-6">
            <div
              className="bg-gradient-to-r from-emerald-400 to-green-500 h-2.5 rounded-full transition-all duration-700"
              style={{
                width: `${Math.min(
                  (amount?.data?.amount_available || 0) * 20,
                  100
                )}%`,
              }}
            ></div>
          </div>
          <div className=" flex items-center justify-center text-gray-700 ">
            <AlertCircle className="w-4 h-4 text-amber-600 mr-2 flex-shrink-0" />
            <p className="text-center text-red-500">
              Once published, it cannot be edited.
            </p>
          </div>
        </div>

        {/* Footer - Buttons */}
        <div className="px-6 py-5 bg-gray-50 border border-t-emerald-100 flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-4">
          <button
            className="px-6 py-3.5 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-xl hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 transition-all duration-200 shadow-sm hover:shadow-md"
            onClick={props.onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className={`px-6 py-3.5 text-base font-semibold text-white bg-gradient-to-r from-emerald-500 to-green-600 rounded-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-400 transition-all duration-300 flex items-center justify-center relative overflow-hidden group ${
              isLoading || amount?.data?.amount_available < 1
                ? "opacity-85 cursor-not-allowed"
                : "hover:shadow-lg"
            }`}
            onClick={handleConfirm}
            disabled={isLoading || amount?.data?.amount_available < 1}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* Animated background on hover */}
            <span className="absolute inset-0 bg-gradient-to-r from-emerald-600 to-green-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>

            {isLoading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-2 h-5 w-5 text-white relative z-10"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span className="relative z-10">Publishing...</span>
              </>
            ) : (
              <span className="relative z-10 flex items-center">
                <svg
                  className="w-5 h-5 mr-2 transition-transform duration-300 group-hover:scale-110"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Publish Now
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
}
